var _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoKaeltemittel48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24,14 23.3,14.4 23.3,17 21.6,15.4 20.3,16.2 23.3,19.2 23.3,20.9 21.8,21.8 20.3,20.9 19.2,16.8 17.9,17.6  18.5,19.9 16.2,18.6 15.5,19 15.5,19.9 17.7,21.2 15.5,21.8 15.5,23.3 19.5,22.2 21,23.1 21,24.9 19.5,25.8 15.5,24.7 15.5,26.2  17.7,26.8 15.5,28.1 15.5,29 16.2,29.4 18.5,28.1 17.9,30.4 19.2,31.2 20.3,27.1 21.8,26.2 23.3,27.1 23.3,28.8 20.3,31.8  21.6,32.6 23.3,30.9 23.3,33.6 24,34 24.7,33.6 24.7,31 26.4,32.6 27.7,31.8 24.7,28.8 24.7,27.1 26.2,26.2 27.7,27.1 28.8,31.2  30.1,30.4 29.5,28.1 31.8,29.4 32.5,29 32.5,28.1 30.3,26.8 32.5,26.2 32.5,24.7 28.5,25.8 27,24.9 27,23.1 28.5,22.2 32.5,23.3  32.5,21.8 30.3,21.2 32.5,19.9 32.5,19 31.8,18.6 29.5,19.9 30.1,17.6 28.8,16.8 27.7,20.9 26.2,21.8 24.7,20.9 24.7,19.1  27.7,16.2 26.3,15.4 24.7,17 24.7,14.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoKaeltemittel48);
export default __webpack_public_path__ + "static/media/ic_bevo_kaeltemittel_48.9e8b711498e7690f81496d54f2a418a7.svg";
export { ForwardRef as ReactComponent };